(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Stately-stately-concurrent-collections'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Stately-stately-concurrent-collections'.");
    }
    root['Stately-stately-concurrent-collections'] = factory(typeof this['Stately-stately-concurrent-collections'] === 'undefined' ? {} : this['Stately-stately-concurrent-collections'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var VOID = kotlin_kotlin.$_$.g;
  var protoOf = kotlin_kotlin.$_$.hb;
  var Collection = kotlin_kotlin.$_$.g5;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var KtMutableMap = kotlin_kotlin.$_$.q5;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  var KtMutableSet = kotlin_kotlin.$_$.r5;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ConcurrentMutableCollection, 'ConcurrentMutableCollection', VOID, VOID, [Collection]);
  initMetadataForClass(ConcurrentMutableIterator, 'ConcurrentMutableIterator');
  initMetadataForClass(ConcurrentMutableMap, 'ConcurrentMutableMap', ConcurrentMutableMap_init_$Create$, VOID, [KtMutableMap]);
  initMetadataForClass(ConcurrentMutableSet, 'ConcurrentMutableSet', ConcurrentMutableSet_init_$Create$, ConcurrentMutableCollection, [ConcurrentMutableCollection, KtMutableSet]);
  //endregion
  function ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this$0) {
    return function () {
      return this$0.e2e_1.j();
    };
  }
  function ConcurrentMutableCollection$contains$lambda(this$0, $element) {
    return function () {
      return this$0.e2e_1.r($element);
    };
  }
  function ConcurrentMutableCollection$containsAll$lambda(this$0, $elements) {
    return function () {
      return this$0.e2e_1.r1($elements);
    };
  }
  function ConcurrentMutableCollection$isEmpty$lambda(this$0) {
    return function () {
      return this$0.e2e_1.o();
    };
  }
  function ConcurrentMutableCollection$add$lambda(this$0, $element) {
    return function () {
      return this$0.e2e_1.e($element);
    };
  }
  function ConcurrentMutableCollection$addAll$lambda(this$0, $elements) {
    return function () {
      return this$0.e2e_1.n($elements);
    };
  }
  function ConcurrentMutableCollection$clear$lambda(this$0) {
    return function () {
      this$0.e2e_1.s1();
      return Unit_instance;
    };
  }
  function ConcurrentMutableCollection$iterator$lambda(this$0) {
    return function () {
      return new ConcurrentMutableIterator(this$0.f2e_1, this$0.e2e_1.g());
    };
  }
  function ConcurrentMutableCollection(rootArg, del) {
    rootArg = rootArg === VOID ? null : rootArg;
    this.e2e_1 = del;
    var tmp = this;
    tmp.f2e_1 = rootArg == null ? this : rootArg;
  }
  protoOf(ConcurrentMutableCollection).j = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this)();
  };
  protoOf(ConcurrentMutableCollection).r = function (element) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$contains$lambda(this, element)();
  };
  protoOf(ConcurrentMutableCollection).r1 = function (elements) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$containsAll$lambda(this, elements)();
  };
  protoOf(ConcurrentMutableCollection).o = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$isEmpty$lambda(this)();
  };
  protoOf(ConcurrentMutableCollection).e = function (element) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$add$lambda(this, element)();
  };
  protoOf(ConcurrentMutableCollection).n = function (elements) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$addAll$lambda(this, elements)();
  };
  protoOf(ConcurrentMutableCollection).s1 = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    ConcurrentMutableCollection$clear$lambda(this)();
  };
  protoOf(ConcurrentMutableCollection).g = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.f2e_1;
    return ConcurrentMutableCollection$iterator$lambda(this)();
  };
  function ConcurrentMutableIterator$hasNext$lambda(this$0) {
    return function () {
      return this$0.h2e_1.h();
    };
  }
  function ConcurrentMutableIterator$next$lambda(this$0) {
    return function () {
      return this$0.h2e_1.i();
    };
  }
  function ConcurrentMutableIterator$remove$lambda(this$0) {
    return function () {
      this$0.h2e_1.w3();
      return Unit_instance;
    };
  }
  function ConcurrentMutableIterator(root, del) {
    this.g2e_1 = root;
    this.h2e_1 = del;
  }
  protoOf(ConcurrentMutableIterator).h = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.g2e_1;
    return ConcurrentMutableIterator$hasNext$lambda(this)();
  };
  protoOf(ConcurrentMutableIterator).i = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.g2e_1;
    return ConcurrentMutableIterator$next$lambda(this)();
  };
  protoOf(ConcurrentMutableIterator).w3 = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.g2e_1;
    ConcurrentMutableIterator$remove$lambda(this)();
  };
  function ConcurrentMutableMap_init_$Init$($this) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var tmp$ret$0 = LinkedHashMap_init_$Create$();
    ConcurrentMutableMap.call($this, null, tmp$ret$0);
    return $this;
  }
  function ConcurrentMutableMap_init_$Create$() {
    return ConcurrentMutableMap_init_$Init$(objectCreate(protoOf(ConcurrentMutableMap)));
  }
  function ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this$0) {
    return function () {
      return this$0.i2e_1.j();
    };
  }
  function ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this$0) {
    return function () {
      return new ConcurrentMutableSet(this$0, this$0.i2e_1.t());
    };
  }
  function ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this$0) {
    return function () {
      return new ConcurrentMutableSet(this$0, this$0.i2e_1.z1());
    };
  }
  function ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this$0) {
    return function () {
      return new ConcurrentMutableCollection(this$0, this$0.i2e_1.a2());
    };
  }
  function ConcurrentMutableMap$containsKey$lambda(this$0, $key) {
    return function () {
      return this$0.i2e_1.w1($key);
    };
  }
  function ConcurrentMutableMap$get$lambda(this$0, $key) {
    return function () {
      return this$0.i2e_1.y1($key);
    };
  }
  function ConcurrentMutableMap$isEmpty$lambda(this$0) {
    return function () {
      return this$0.i2e_1.o();
    };
  }
  function ConcurrentMutableMap$clear$lambda(this$0) {
    return function () {
      this$0.i2e_1.s1();
      return Unit_instance;
    };
  }
  function ConcurrentMutableMap$put$lambda(this$0, $key, $value) {
    return function () {
      return this$0.i2e_1.b2($key, $value);
    };
  }
  function ConcurrentMutableMap$putAll$lambda(this$0, $from) {
    return function () {
      this$0.i2e_1.d2($from);
      return Unit_instance;
    };
  }
  function ConcurrentMutableMap$remove$lambda(this$0, $key) {
    return function () {
      return this$0.i2e_1.c2($key);
    };
  }
  function ConcurrentMutableMap(rootArg, del) {
    rootArg = rootArg === VOID ? null : rootArg;
    this.i2e_1 = del;
    var tmp = this;
    tmp.j2e_1 = rootArg == null ? this : rootArg;
  }
  protoOf(ConcurrentMutableMap).j = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this)();
  };
  protoOf(ConcurrentMutableMap).t = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this)();
  };
  protoOf(ConcurrentMutableMap).z1 = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this)();
  };
  protoOf(ConcurrentMutableMap).a2 = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this)();
  };
  protoOf(ConcurrentMutableMap).w1 = function (key) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$containsKey$lambda(this, key)();
  };
  protoOf(ConcurrentMutableMap).y1 = function (key) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$get$lambda(this, key)();
  };
  protoOf(ConcurrentMutableMap).o = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$isEmpty$lambda(this)();
  };
  protoOf(ConcurrentMutableMap).s1 = function () {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    ConcurrentMutableMap$clear$lambda(this)();
  };
  protoOf(ConcurrentMutableMap).b2 = function (key, value) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$put$lambda(this, key, value)();
  };
  protoOf(ConcurrentMutableMap).d2 = function (from) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    ConcurrentMutableMap$putAll$lambda(this, from)();
  };
  protoOf(ConcurrentMutableMap).c2 = function (key) {
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    this.j2e_1;
    return ConcurrentMutableMap$remove$lambda(this, key)();
  };
  function ConcurrentMutableSet_init_$Init$($this) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var tmp$ret$0 = LinkedHashSet_init_$Create$();
    ConcurrentMutableSet.call($this, null, tmp$ret$0);
    return $this;
  }
  function ConcurrentMutableSet_init_$Create$() {
    return ConcurrentMutableSet_init_$Init$(objectCreate(protoOf(ConcurrentMutableSet)));
  }
  function ConcurrentMutableSet(rootArg, del) {
    ConcurrentMutableCollection.call(this, rootArg, del);
    this.m2e_1 = del;
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ConcurrentMutableMap_init_$Create$;
  //endregion
  return _;
}));
